import { useState } from 'react';
import { ETATS_RECLAMATION_RESEAU } from '@eec/contrats';
import { requetePublique } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
export function ReclamationPubliqueGenerale({
  organisations,
}: {
  organisations: { id: string; nom: string; fictive: boolean }[];
}) {
  const [code, setCode] = useState('');
  const [recu, setRecu] = useState<{ reference: string; code_suivi: string } | null>(null);
  const [suivi, setSuivi] = useState<{
    reference: string;
    statut: keyof typeof ETATS_RECLAMATION_RESEAU;
    reponse: string | null;
  } | null>(null);
  const [erreur, setErreur] = useState('');
  const [occupe, setOccupe] = useState(false);
  return (
    <section aria-label="Réclamation sans signalement préalable" style={{ marginBlock: 28 }}>
      <h2>Réclamation sans signalement préalable</h2>
      <p>
        Pour une demande concernant le service, sans déclaration d’interruption. Pour une panne ou
        un danger, utilisez le formulaire de signalement et ses consignes. Évitez les données
        personnelles inutiles.
      </p>
      {erreur && <p role="alert">{erreur}</p>}
      {!recu && organisations.length > 0 && (
        <details>
          <summary>Déposer une réclamation générale</summary>
          <form
            style={{ display: 'grid', gap: 12 }}
            onSubmit={async (e) => {
              e.preventDefault();
              const d = new FormData(e.currentTarget);
              setErreur('');
              setOccupe(true);
              setSuivi(null);
              try {
                const r = await requetePublique<{ reference: string; code_suivi: string }>(
                  '/portail-public/reclamations-generales',
                  {
                    organisation_id: d.get('organisation_id'),
                    contenu: d.get('contenu'),
                    site_web: d.get('site_web'),
                  },
                );
                setRecu(r);
                setCode(r.code_suivi);
              } catch (err) {
                setErreur(messageErreur(err));
              } finally {
                setOccupe(false);
              }
            }}
          >
            <label>
              Exploitant destinataire de la réclamation{' '}
              <select name="organisation_id" required defaultValue="">
                <option value="">Choisir</option>
                {organisations.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.nom}
                    {o.fictive ? ' (démonstration)' : ''}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Contenu de la réclamation générale{' '}
              <textarea name="contenu" required minLength={10} maxLength={2000} rows={4} />
            </label>
            <div hidden aria-hidden="true">
              <input name="site_web" tabIndex={-1} autoComplete="off" />
            </div>
            <button disabled={occupe}>Déposer ma réclamation générale</button>
          </form>
        </details>
      )}
      {recu && (
        <div role="status">
          <h3>Réclamation générale enregistrée</h3>
          <p>Référence : {recu.reference}</p>
          <p>
            Conservez ce code secret : il permet de consulter la réponse. Il ne sera pas envoyé par
            courriel et ne peut pas être récupéré en cas de perte.
          </p>
          <label>
            Votre code secret de réclamation{' '}
            <input readOnly value={recu.code_suivi} onFocus={(e) => e.currentTarget.select()} />
          </label>
        </div>
      )}
      <form
        style={{ display: 'grid', gap: 12, marginBlock: 18 }}
        onSubmit={async (e) => {
          e.preventDefault();
          setErreur('');
          setSuivi(null);
          setOccupe(true);
          try {
            setSuivi(
              await requetePublique('/portail-public/reclamations-generales/suivi', {
                code: code.trim(),
              }),
            );
          } catch (err) {
            setErreur(messageErreur(err));
          } finally {
            setOccupe(false);
          }
        }}
      >
        <label>
          Code secret de réclamation générale{' '}
          <input
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setSuivi(null);
            }}
            required
            autoComplete="off"
            spellCheck={false}
          />
        </label>
        <button disabled={occupe}>Consulter ma réclamation générale</button>
      </form>
      {suivi && (
        <section aria-label="Suivi de la réclamation générale">
          <p>{ETATS_RECLAMATION_RESEAU[suivi.statut]}</p>
          <p>Référence : {suivi.reference}</p>
          {suivi.reponse && <p>{suivi.reponse}</p>}
        </section>
      )}
    </section>
  );
}
